import { CTABand } from '@/components/sections/CTABand';
import { GuaranteeStrip } from '@/components/sections/GuaranteeStrip';
import { Seo, breadcrumbJsonLd, organizationJsonLd } from '@/lib/seo';
import { company } from '@/data/company';

export default function About() {
  return (
    <>
      <Seo
        title={`About Us | Trusted Local Building Contractors in Essex`}
        description={`Meet the team behind ${company.legalName}. A local, family-run contracting company serving ${company.serviceCoverage} from our hub in ${company.hub}. Fully insured, all work guaranteed, no call-out charges.`}
        path="/about"
        keywords="about Bliss Building Contractors, local builders Essex, family-run contractors Braintree, trusted contractors London Essex Suffolk"
        jsonLd={[
          organizationJsonLd(),
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'About', path: '/about' },
          ]),
        ]}
      />

      <section className="bg-navy-900 pt-16 lg:pt-20">
        <div className="container-page py-16 text-paper-0 sm:py-20">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-300">About us</p>
          <h1 className="mt-2 font-display text-4xl font-bold sm:text-5xl">
            Local contractors. Comprehensive coverage.
          </h1>
          <p className="mt-4 max-w-2xl text-paper-0/85">
            Providing comprehensive regional coverage with an extensive footprint across
            {' '}{company.serviceCoverage}. From our hub in {company.hub}, we deliver
            high-tier building contracting services to homes and businesses across the region.
          </p>
        </div>
      </section>

      <section className="container-page py-16 sm:py-20">
        <div className="prose-bliss mx-auto">
          <h2>Our approach</h2>
          <p>
            Building your dream shouldn’t be stressful. The best projects start with a simple
            conversation - whether you’re worried about a leaky pipe or planning a full
            extension, we’re here to listen and solve it with you.
          </p>
          <p>
            Instead of saying you <em>can’t</em> do something, we’ll always tell you what we
            <em> can</em> do, and walk you through the options. Our team is professionally
            trained, fully insured, and used to running well-organised jobs end to end.
          </p>
          <h2>Why customers choose us</h2>
          <ul className="chevron-list space-y-2">
            {company.guarantees.map((g) => (<li key={g}>{g}</li>))}
            <li>Local team - based in {company.hub}, working across {company.serviceCoverage}</li>
            <li>One point of contact from quote to handover</li>
          </ul>
          <h2>Trades we cover</h2>
          <p>
            From roofing services and full new roof installations to driveways, landscaping,
            damp proofing and spray foam insulation removal, every job is delivered in-house
            by our own team. That means consistent standards, accountable timescales, and one
            clear line of communication for the whole project.
          </p>
        </div>
      </section>

      <GuaranteeStrip />
      <CTABand />
    </>
  );
}
